import React, { Component } from "react";
import moment from "moment";
import { getUserTimeZone } from "../../../Utils/UserFunctions";
import { getDateFormat } from "../../../Utils/UserFunctions";
import HeaderTabs from "../../../Components/UI/HeaderTabs";


class CertificateDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isCertificateUploadOpen: true,
      isKeyChainUploadOpen: true,
      activeTab: "uploadCertificate",
      activeKeyTab: "uploadKey",
      activecsrTab: "caSigning",
      csrTabs: [
        {
          name: "CA Signed",
          attributes: {
            "aria-selected": true,
            id: "caSigning",
            className: "nav-link show active",
          },
          clickHandler: this.onUploadTypeChange.bind(this, "csr", "caSigning"),
        },
        {
          name: "Self Signed",
          attributes: {
            "aria-selected": false,
            id: "shipcrmSigning",
            className: "nav-link",
          },
          clickHandler: this.onUploadTypeChange.bind(
            this,
            "csr",
            "shipcrmSigning"
          ),
        },
      ],
      certificateTabs: [
        {
          name: "Upload Certificate",
          attributes: {
            "aria-selected": true,
            id: "uploadCertificate",
            className: "nav-link show active",
          },
          clickHandler: this.onUploadTypeChange.bind(
            this,
            "certificate",
            "uploadCertificate"
          ),
        },
        {
          name: "Paste Certificate",
          attributes: {
            "aria-selected": false,
            id: "pasteCertificate",
            className: "nav-link",
          },
          clickHandler: this.onUploadTypeChange.bind(
            this,
            "certificate",
            "pasteCertificate"
          ),
        },
      ],
      keyTabs: [
        {
          name: "Upload key",
          attributes: {
            "aria-selected": true,
            id: "uploadKey",
            className: "nav-link show active",
          },
          clickHandler: this.onUploadTypeChange.bind(this, "key", "uploadKey"),
        },
        {
          name: "Paste key",
          attributes: {
            "aria-selected": false,
            id: "pasteKey",
            className: "nav-link",
          },
          clickHandler: this.onUploadTypeChange.bind(this, "key", "pasteKey"),
        },
      ],
    };
  }

  copyCSRToClipboard = () => {
    console.log("copytoclipboard");
    const { domainKey } = this.props;
    var csrContent = domainKey.csr;
    // csrContent.select();
    navigator.clipboard.writeText(csrContent);
    console.log("copied successfully");
  };

  onUploadTypeChange = (field, activeTabId) => {
    console.log("onuploadtypeChnage", activeTabId);
    if (field === "certificate") {
      let updatedcertificateTabs = this.state.certificateTabs;
      updatedcertificateTabs.map((tab) => {
        if (tab.attributes.id && tab.attributes.id === activeTabId) {
          tab.attributes.className = "nav-link show active";
        } else {
          tab.attributes.className = "nav-link";
        }
        return tab;
      });
      this.setState({
        activeTab: activeTabId,
        certificateTabs: [...updatedcertificateTabs],
      });
    } else if (field === "key") {
      let updatedKeyTabs = this.state.keyTabs;
      updatedKeyTabs.map((tab) => {
        if (tab.attributes.id && tab.attributes.id === activeTabId) {
          tab.attributes.className = "nav-link show active";
        } else {
          tab.attributes.className = "nav-link";
        }
        return tab;
      });
      this.setState({
        activeKeyTab: activeTabId,
        keyTabs: [...updatedKeyTabs],
      });
    } else if (field === "csr") {
      let updateCsrTabs = this.state.csrTabs;
      updateCsrTabs.map((tab) => {
        if (tab.attributes.id && tab.attributes.id === activeTabId) {
          tab.attributes.className = "nav-link show active";
        } else {
          tab.attributes.className = "nav-link";
        }
        return tab;
      });
      this.setState({ activecsrTab: activeTabId, csrTabs: [...updateCsrTabs] });
    }
  };

  render() {
    console.log("CreateDomainCertificate.this.props", this.props);
    const { isModelOpen, certificateTextValue, keyTextArea, item, domainKey } =
      this.props;

    const Tittle = "Add Domain Certificate";
    let certificateFileName = "";
    let keyChainFileName = "";
    var date = Date.parse(item.created_at);
    let userTimeFormat = moment()
      .tz(getUserTimeZone())
      .format("YYYY-MM-DDTHH:mm:ss");
    let createdDate = moment(item.created_at).format(getDateFormat("Date"));
    let createTime = moment(item.created_at).format("HH:mm");
    console.log(
      "date",
      date,
      "createdDate",
      createdDate,
      "createTime",
      createTime
    );
    console.log("createdDate", createdDate);
    if (this.props.certificateFile.name !== undefined) {
      console.log("certificateFileNAme", this.props.certificateFile.name);
      certificateFileName = this.props.certificateFile.name;
    }
    if (this.props.keyChainFile.name !== undefined) {
      keyChainFileName = this.props.keyChainFile.name;
    }
    const buttonList = [
      {
        attributes: {
          id: "closeAddNewDomainName",
          className: "btn btn-border btn-default",
          "data-dismiss": "modal",
        },
        clickHandler: this.props.toggleModel.bind(this, null),
        name: "cancel",
      },
      {
        attributes: {
          className: "btn primary_bg",
        },
        clickHandler: this.props.saveHandler,
        name: "add",
      },
    ];
    if (isModelOpen === true) {
      // $(".nav-link").click(function(){
      //   $(".nav-link").removeClass('show active');
      //   $("#"+this.id).addClass('show active');
      //   $(".myTab").removeClass('show active');
      //   $(".myTab").removeClass('d-flex');
      //   $(".myTab").removeClass('d-none');
      //   $("#"+this.id+"_div").addClass('show active');
      //   $("#"+this.id+"_div").addClass('d-flex');
      // });
    } else {
    }

    return (
      <>
        <div className={isModelOpen ? "quick_sidebar_open" : ""}>
          <div className="actionToggler quick-sidebar p-0">
            <a
              href="#"
              className="close-quick-sidebar"
              onClick={(e) => this.props.toggleModel([])}
              style={{ top: 0, right: "10px", zIndex: 1 }}
            >
              <i className="fas fa-times fa-lg" />
            </a>
            <div className="view">
  <div className="modal-header">
    <h4 className="mb-0"> Certificate Details</h4>
  </div>
  <div className="modal-body" style={{ flex: "revert" }}>
    <div className="accordionTheme" id="certifcateAcc">
      <div className="accordion-item">
        <h2 className="accordion-header" id="headingOne">
          <button
            type="button"
            className="accordion-button"
            data-toggle="collapse"
            data-target="#certifcateInfo"
          >
            1. Certifatcte Info{" "}
          </button>
        </h2>
        <div
          id="certifcateInfo"
          className="accordion-collapse collapse show"
          data-parent="#certifcateAcc"
        >
          <div className="card-body">
            <div className="row">
              <div className="col-md-6 col-12">
                <div className="form-group row pl-2">
                  <label
                    title="First Name"
                    className="fourth_dark_color col-md-4 col-5 text-right text-truncate"
                  >
                    {" "}
                    Domain Name
                  </label>
                  <div className="col-md-8 col-7">
                    <span> {item.common_name} </span>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div className="form-group row pl-2">
                  <label
                    title="First Name"
                    className="fourth_dark_color col-md-4 col-5 text-right text-truncate"
                  >
                    {" "}
                    Certificate Type{" "}
                  </label>
                  <div className="col-md-8 col-7">
                    <span> {item.type}</span>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div className="form-group row pl-2">
                  <label
                    title="First Name"
                    className="fourth_dark_color col-md-4 col-5 text-right text-truncate"
                  >
                    {" "}
                    Is Active{" "}
                  </label>
                  <div className="col-md-8 col-7">
                    <span>
                    {item.is_active ? (
                              <i className="fas fa-check	text-success fa-lg" />
                            ) : (
                              <i className="fas fa-times text-danger fa-lg"></i>
                            )}{" "}
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div className="form-group row pl-2">
                  <label
                    title="First Name"
                    className="fourth_dark_color col-md-4 col-5 text-right text-truncate"
                  >
                    {" "}
                    Created at
                  </label>
                  <div className="col-md-8 col-7">
                    <span>
                    {" "}
                            {createdDate}{" "}
                            <span className="text-danger text-small">
                              {" "}
                              {createTime}{" "}
                            </span>{" "}
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div className="form-group row pl-2">
                  <label title="First Name" className="fourth_dark_color col-md-4 col-5 text-right text-truncate" > {" "} Key Size{" "} </label>
                  <div className="col-md-8 col-7">
                    <span> {item.key_size}  </span>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div className="form-group row pl-2">
                  <label title="First Name" className="fourth_dark_color col-md-4 col-5 text-right text-truncate" > {" "} Certificate Expiry Date </label>
                  <div className="col-md-8 col-7">
                    <span>  {" "} {item.expiry_date !== undefined ? moment(item.expiry_date).format(getDateFormat()) : "-"}{" "}</span>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div className="form-group row pl-2">
                  <label
                    title="First Name"
                    className="fourth_dark_color col-md-4 col-5 text-right text-truncate"
                  >
                    {" "}
                    Certificate{" "}
                  </label>
                  <div className="col-md-8 col-7">
                    <span> - </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="accordion-item">
        <h2 className="accordion-header" id="headingTwo">
          <button
            type="button"
            className="accordion-button collapsed"
            data-toggle="collapse"
            data-target="#certifcateUploadDownload"
          >
            2. Certificate Upload / Download Details{" "}
          </button>
        </h2>
        <div
          id="certifcateUploadDownload"
          className="accordion-collapse collapse"
          data-parent="#certifcateAcc"
        >
          <div className="pillsTab" id="pillsTabContent">
            <div className={(domainKey.csr!==undefined && domainKey.csr!=="")?"card m-3":"card m-3 d-none"}>
              <div className="card-header cursor-pointer sectionHeader pl-1 p-2 position-relative">
                <div
                  className="card-title d-flex align-items-center justify-content-between"
                  data-toggle="collapse"
                  href="#caSigned"
                  aria-expanded="true"
                >
                  <h6 className="mb-0"> Certifcate Signed / Self Signed </h6>
                  <div className="span-mode" />
                </div>
              </div>
              <div
                className="card-body m-2 p-0 show"
                id="caSigned"
                style={{
                  border: "2px dashed rgb(221, 224, 227)",
                  background: "rgb(255, 255, 255)"
                }}
                data-parent="#pillsTabContent"
              >
                <ul
                  className="nav nav-pills navcrm-primary nav-pills-no-bd border-bottom px-2"
                  role="tablist"
                >
                  <li className="nav-item">
                    <a
                      data-toggle="tab"
                      role="tab"
                      aria-selected="true"
                      className="nav-link show active"
                      href="#caSigning"
                    >
                      CA Signed
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      data-toggle="tab"
                      role="tab"
                      aria-selected="false"
                      className="nav-link"
                      href="#shipcrmSigning"
                    >
                      Self Signed
                    </a>
                  </li>
                </ul>
                <div className="tab-content p-2">
                  <div id="caSigning" className="tab-pane fade active show">
                    <div>
                      <p className="text-center">
                        Download the CSR file and upload to any Authorized
                        Certificate provider and get certificate file for your
                        domain
                      </p>
                    </div>
                    <div className="d-flex align-items-center justify-content-center">
                      <div className="col-xs-4">
                        <span
                          name="csr"
                          onClick={(e) =>
                            this.props.fileDownload(item.id, "csr")
                          }
                          className="input-group-text cursor-pointer"
                        >
                          <i className="fas fa-cloud-download-alt fa-lg text-info pr-2" />{" "}
                          Download Generated CSR
                        </span>
                     
                    </div>
                      <div className="col-xs-4 ml-2">
                          <span className="input-group-text cursor-pointer"  onClick={this.copyCSRToClipboard} >
                          <i className="fa fa-copy fa-lg text-info pr-2" />
                          Copy to Clipboard
                        </span>
                      </div>
                    </div>
                  </div>
                  <div id="shipcrmSigning" className="tab-pane fade">
                    <div>
                      <p className="text-center">
                        self Authorized certificate can be generated
                      </p>
                    </div>
                    <div className="d-flex align-items-center justify-content-center mt-2">
                      <div className="col-xs-4">
                        <span name="csr" className="input-group-text cursor-pointer" onClick={(e) => this.props.getSelfAuthorizedCertificate( item.id ) } >
                          <i className="fas fa-cloud-download-alt fa-lg text-info pr-2" />{" "}
                          Activate Self Signing
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card m-3">
              <div className="card-header cursor-pointer sectionHeader pl-1 p-2 position-relative">
                <div
                  className="card-title d-flex align-items-center justify-content-between collapsed"
                  data-toggle="collapse"
                  href="#uCertif"
                  aria-expanded="false"
                >
                  <h6 className="mb-0"> Upload / Paste Certificate </h6>
                  <div className="span-mode" />
                </div>
              </div>
              <div
                className="card-body m-2 p-2 collapse"
                id="uCertif"
                style={{
                  border: "2px dashed rgb(221, 224, 227)",
                  background: "rgb(255, 255, 255)"
                }}
                data-parent="#pillsTabContent"
              >
                 <div className="">
                                {domainKey !== null && domainKey.certificate_file !== undefined && domainKey.certificate_file !== "" ? (
                                  <>
                                    <p className="text-success"> {" "} <i className="fas fa-check-circle mr-2"></i> Your certificate Uploaded Successfully. To modify the certificate upload again </p>
                                  </>
                                ) : ( "" )}
                  </div>
                <ul
                  className="nav nav-pills navcrm-primary nav-pills-no-bd px-2"
                  role="tablist"
                >
                  <li className="nav-item">
                    <a
                      data-toggle="tab"
                      role="tab"
                      aria-selected="true"
                      className="nav-link show active"
                      href="#uploadCertificate"
                    >
                      Upload Certificate
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      data-toggle="tab"
                      role="tab"
                      aria-selected="false"
                      className="nav-link"
                      href="#pasteCertificate"
                    >
                      Paste Certificate
                    </a>
                  </li>
                </ul>
                <div className="tab-content">
                  <div
                    id="uploadCertificate"
                    className="tab-pane fade active show"
                  >
                    <div className="d-flex mt-4">
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <button className="btn border browseCSV primary_bg">
                            <input
                              id="certificatePicker"
                              accepts=".pem,.crt,.cer,.key"
                              type="file"
                              onChange={(e) =>
                                this.props.fileClickHandler(
                                  item.id,
                                  e
                                )
                              }
                              name="certificate"
                            />
                            Choose Certificate
                          </button>
                        </div>
                        <input
                          type="text"
                          name="filename"
                          className="form-control"
                          readOnly
                          placeholder={
                            certificateFileName === ""
                              ? "No file selected"
                              : certificateFileName
                          }
                          id={item.id}
                        />
                      </div>
                      <div className=" pl-2">
                        <span className="input-group-text cursor-pointer btn primary_bg"  onClick={(e) => this.props.uploadFileHandler( "certificate", item.id ) }>
                          {" "}
                          Upload
                        </span>
                      </div>
                    </div>
                  </div>
                  <div id="pasteCertificate" className="tab-pane fade">
                    <div className="d-flex mt-4">
                      <textarea
                        placeholder=""
                        onChange={this.props.valueChangeHandler}
                        name="certificateTextArea"
                        className="form-control"
                        maxLength={5000}
                        decimal={0}
                        value={certificateTextValue}
                      />
                      <div className="text-center pl-2">
                        <span  onClick={(e) => this.props.uploadFileHandler( "certificateTextValue", item.id ) } className="input-group-text cursor-pointer btn primary_bg"> {" "} Upload </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card m-3">
              <div className="card-header cursor-pointer sectionHeader pl-1 p-2 position-relative">
                <div
                  className="card-title d-flex align-items-center justify-content-between collapsed"
                  data-toggle="collapse"
                  href="#keyCertif"
                  aria-expanded="false"
                >
                  <h6 className="mb-0"> Upload / Paste key-chain </h6>
                  <div className="span-mode" />
                </div>
              </div>
              <div
                className="card-body m-2 p-2 collapse"
                id="keyCertif"
                style={{
                  border: "2px dashed rgb(221, 224, 227)",
                  background: "rgb(255, 255, 255)"
                }}
                data-parent="#pillsTabContent"
              >
                 <div className="text-success pt-3 ">
                                {domainKey !== null &&
                                domainKey.key_chanin_file !== undefined &&
                                domainKey.key_chanin_file !== "" ? (
                                  <>
                                    <p>
                                      {" "}
                                      {/* <i className="fas fa-check-circle mr-2"></i>{" "} */}
                                      KeyChain Uploaded Successfully. To modify
                                      the keyChain upload again
                                    </p>
                                  </>
                                ) : (
                                  ""
                                )}
                    </div>
                <ul
                  className="nav nav-pills navcrm-primary nav-pills-no-bd px-2"
                  role="tablist"
                >
                  <li className="nav-item">
                    <a
                      data-toggle="tab"
                      role="tab"
                      aria-selected="true"
                      className="nav-link show active"
                      href="#uploadKey"
                    >
                      Upload key
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      data-toggle="tab"
                      role="tab"
                      aria-selected="false"
                      className="nav-link"
                      ariaselected="false"
                      href="#pasteKey"
                    >
                      Paste key
                    </a>
                  </li>
                </ul>
                <div className="tab-content">
                  <div id="uploadKey" className="tab-pane fade active show">
                    <div className="d-flex mt-4">
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <button className="btn border browseCSV primary_bg">
                            <input
                              type="file"
                              accepts=".pem,.crt,.cer,.key"
                              name="key_chain"
                              onChange={(e) =>
                                this.props.fileClickHandler(
                                  item.id,
                                  e
                                )
                              }
                            />
                            Choose Key-Chain
                          </button>
                        </div>
                        <input
                          type="text"
                          name="filename"
                          className="form-control"
                          placeholder={
                            keyChainFileName === ""
                              ? "No file selected"
                              : keyChainFileName
                          }
                          readOnly
                          id={item.id}
                        />
                      </div>
                      <div className=" pl-2">
                        <span className="input-group-text cursor-pointer btn primary_bg"  onClick={(e) =>
                                      this.props.uploadFileHandler(
                                        "key_chain",
                                        item.id
                                      )
                                    } >
                          {/* <i className="fas fa-cloud-upload-alt fa-lg text-info pr-2" />{" "} */}
                          Upload
                        </span>
                      </div>
                    </div>
                  </div>
                 
                  <div id="pasteKey" className="tab-pane fade">
                    <div className="d-flex mt-4">
                      <textarea
                        onChange={this.props.valueChangeHandler}
                        placeholder=""
                        name="keyChainTextArea"
                        className="form-control"
                        maxLength={5000}
                        decimal={0}
                        value={keyTextArea}
                      />
                      <div className="text-center pl-2">
                        <span   onClick={(e) => this.props.uploadFileHandler( "keyChainTextValue", item.id ) } className="input-group-text cursor-pointer btn primary_bg"> {" "} Upload </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

          </div>
        </div>
        {(isModelOpen)?<div className="quick-sidebar-overlay"></div>:""}
      </>
    );
  }
}

export default CertificateDetail;
